import React, { Suspense } from "react";
const ChangeThankYouOfferingModal = React.lazy(() =>
  import("./ChangeThankYouOfferingModal").then((m) => ({
    default: m.ChangeThankYouOfferingModal,
  }))
);

export const LazyLoadedChangeThankYouOfferingModal = (props) => {
  return (
    <Suspense fallback={null}>
      <ChangeThankYouOfferingModal {...props} />
    </Suspense>
  );
};

export default LazyLoadedChangeThankYouOfferingModal;
